import React, { useEffect, useState } from 'react';
import { Icon } from '../../_components';
import { useApp, useModal } from '../../_contexts';
import { getArticleData } from '../../_services';

export function SidebarOptions({ item, type }) {
  const [article, setArticle] = useState(undefined);
  const { editMode, closeSidebar } = useApp();
  const { openModal } = useModal();

  const handleEditClick = () => {
    //Need to fix this!
    switch (type) {
      case 'event':
        closeSidebar();
        openModal('newEvent', { eventItem: item });
        break;
      case 'location':
        closeSidebar();
        openModal('mapMarker', { event: { props: { marker: item } } });
        break;
      case 'chronicle':
        // console.log('Not yet implemented! Needs ChronicleSettings!');
        // closeSidebar();
        closeSidebar();
        openModal('chronicleSettings');
        break;
    }
  };

  useEffect(() => {
    if (item && item.waID && item.waID.length > 0) {
      let loading = true;
      getArticleData(item.waID).then((result) => {
        if (loading && result && result.data) {
          setArticle(result.data);
        }
      });
      return () => (loading = false);
    }
  }, []);

  return (
    <div className="chronos-sidebar-options">
      {article && article.id && (
        <div className="chronos-sidebar-read-more">
          <a
            href={article.url}
            className="chronos-sidebar-link chronos-sidebar-article-link"
            target="_blank"
          >
            <Icon icon="far fa-external-link" />
            &nbsp;{article.title ? article.title : 'Read More'}
          </a>
        </div>
      )}
      {editMode && (
        <a
          className="chronos-sidebar-link chronos-sidebar-edit-link"
          onClick={handleEditClick}
        >
          <Icon icon="fas fa-pencil" />
          &nbsp;Edit this {type}
        </a>
      )}
    </div>
  );
}
